module.exports = __webpack_public_path__ + "img/kverneland_optima_tfprofi.e5283929.jpg";